import Divider from '@/components/divider/Divider'
import Image from '@/components/image/Image'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid2'
import React from 'react'

const History: React.FC = () => {
  return (
    <Grid
      container
      direction="column"
      columnSpacing={2}
      justifyContent="center"
      alignItems="center"
      textAlign="center"
    >
      <Grid size={10}>
        <h1>Historia</h1>
      </Grid>

      <Grid
        container
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={{ xs: 11, md: 6 }}>
          <h2>Hur det började</h2>
          <p style={{ textAlign: 'left' }}>
            Karlshamns kyrkliga scoutkår bildades på juldagsmorgon 1923 och
            ganska snart kom scoutkåren på idén att ha en egen orkester som
            flera andra scoutkårer runt om i Sverige och världen hade. På
            Valborgsmässoafton 1924 gjorde scoutmusikkåren sitt första
            framträdande till tonerna av bland annat &quot;Längtan till
            landet&quot;.
          </p>
        </Grid>
        <Grid size={{ xs: 11, md: 2 }}>
          <Image
            src="/images/history/history-1.jpg"
            alt="Historia 1"
            loading="eager"
            skeletonHeight={408}
          />
          <i>Alex Westin</i>
          <br />
          <i>Scoutmusikkårens grundare</i>
        </Grid>
      </Grid>

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid
        container
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={{ xs: 11, md: 3 }}>
          <Image
            src="/images/logos/scouterna_logo_round_medium.png"
            alt="Logga"
            loading="eager"
            skeletonHeight={426}
          />
        </Grid>
        <Grid size={{ xs: 11, md: 6 }}>
          <h3>Scoutmetoden + Musik = Scoutmusik = Karlshamns Scoutmusikkår</h3>
          <p style={{ textAlign: 'left' }}>
            Musikkårer har sitt ursprung inom krigsmakten, där även
            scoutrörelsen har sitt ursprung och frågan är om det fortfarande
            finns plats för denna form av scouting inom den moderna
            scoutrörelsen som har blivit allt mindre militäriskt? Svaret är; Ja!
            Musik är en naturlig del av scouting. Ett exempel är våra mysiga
            lägerbål som vi har på kvällarna runt elden.
          </p>
        </Grid>
      </Grid>
      <Grid
        container
        size={{ xs: 11, md: 8 }}
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Grid size={{ xs: 12, md: 6 }}>
          <Image src="/images/history/history-4.jpg" alt="Historia 2" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Image src="/images/history/history-2.jpg" alt="Historia 3" />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <Image src="/images/history/history-3.jpg" alt="Historia 4" />
        </Grid>
      </Grid>

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid
        container
        size={10}
        direction="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <h2>Detaljerad historia</h2>
        <p style={{ textAlign: 'start' }}>
          En mer detaljerad beskrivning kan laddas ner som pdf. Skriven av:
          <i> Lotta Jepson Graveley</i> och <i>Rune Svensson</i>
        </p>

        <a
          href="/documents/Karlshamns-Scoutmusikkårs-Historia.pdf"
          download="Karlshamns-Scoutmusikkårs-Historia.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <Button
            variant="contained"
            sx={{
              color: '#FFFFFF',
              width: 150,
              height: 40,
            }}
          >
            <>
              Ladda ner <PictureAsPdfIcon />
            </>
          </Button>
        </a>
      </Grid>

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid size={10}>
        <h2>Scoutmetoden och Scoutmusikkåren</h2>
        <p>
          Inom scoutrörelsen arbetar man utifrån scoutmetoden, och det gör även
          vi, fast vi har anpassat den utifrån våra unika förutsättningar.
        </p>
      </Grid>

      <Grid
        container
        direction="row"
        size={{ xs: 11, md: 8 }}
        justifyContent="center"
        alignItems="flex-start"
        textAlign="center"
      >
        <Grid size={{ xs: 12, md: 4 }}>
          <h3>Scoutlag & löfte</h3>
          <p style={{ textAlign: 'start' }}>
            För att citera vad scouterna skriver på sin egen hemsida:
            <i>
              &quot;Scoutlagen handlar i grund och botten om att vara en schysst
              kompis och medmänniska. Det är något som scouter försöker leva upp
              till. Scoutlagen finns med i allt vi gör&quot;
            </i>
            och det är precis så vi tycker.
          </p>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <h3>Patrullsystemet</h3>
          <p style={{ textAlign: 'start' }}>
            I musikkåren är det de olika instrument-sektionerna som är
            patrullerna. I varje patrull finns det de som spelat länge och som
            hjälper de som är nya. Och när alla &quot;patruller&quot; arbetar
            tillsammans uppstår ljuv musik.
          </p>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <h3>Learning by doing</h3>
          <p style={{ textAlign: 'start' }}>
            Hos oss behöver du inte vara fullfjädrad musiker för att kunna spela
            med. Det räcker med att man kan grunderna på sitt instrument och att
            du vill lära sig. Vi anpassar noterna efter musikantens nivå. Att
            spela fel gör alla - även de gamla ulvarna - och det är helt ok för
            det är då man lär sig!
          </p>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <h3>Ett stödjande ledarskap</h3>
          <p style={{ textAlign: 'start' }}>
            Vår avdelningsledare kallas för dirigent eller musikalisk ledare.
            Det är han som bestämmer över musiken och med honom finns styrelsen.
            Men alla på avdelningen får komma med förslag på vad, hur och var vi
            skall spela. Dirigenten och styrelsen har alla gått &quot;Trygga
            möten&quot;.
          </p>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <h3>Lokalt och globalt samhällsengagemang</h3>
          <p style={{ textAlign: 'start' }}>
            Musikkåren engagerar sig genom att sprida musikglädje både lokalt
            och globalt genom våra olika spelningar inom kommunen och utomlands.
            Musikkåren står för alla människors lika värde!
          </p>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <h3>Friluftsliv</h3>
          <p style={{ textAlign: 'start' }}>
            Vi har inga vanliga hajker eller läger men vi är utomhus de flesta
            av våra spelningar i alla väderlekar.
          </p>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <h3>Symboliskt ramverk</h3>
          <p style={{ textAlign: 'start' }}>
            En av våra viktigaste ritualer är vår &quot;Go&apos;e fika&quot; som
            vi alltid har under våra avdelningsmöten (repetitioner).
          </p>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default History
